module.exports = __webpack_public_path__ + "media/images/countryrect/im-eb1063aa71a918bcc080c887c5d4a71a.svg";